import ActiveRa from "../../../../../Components/ReverseAuction/ActiveRa/ActiveRa";

const TenderActive = () => {
  return <ActiveRa type={"RA_ACTIVE"} />;
};

export default TenderActive;
